import React, { lazy, Suspense, useLayoutEffect, useEffect, useState } from "react";
// import ShopShape from "./ShopShape";
// import ShopByStyle from "./Shop_by_style";
// import Diamonds from "./Diamonds";
// import Features from "./Features";
// import FineJewelry from "./Fine_jewelry";
// import CustomDesign from "./Custom_design";
// import Testimonial from "./Testimonial";
// import Insta from "./Insta";
// import OurDiff from "./OurDiff";
import { Helmet } from "react-helmet";

import { useSelector } from "react-redux";
// import DynamicHomeBanner from "./DynamicHomeBanner";
// import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { base_url } from "../../Helper/request";
import axios from "axios";
import { Skeleton } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";

// Lazy Loaded Components with Individual Suspense Wrappers
const DynamicHomeBanner = lazy(() => import("./DynamicHomeBanner"));
const ShopShape = lazy(() => import("./ShopShape"));
const TitleContent = lazy(() => import("./TitleContent"));
const ShopByStyle = lazy(() => import("./Shop_by_style"));
const Features = lazy(() => import("./Features"));
const Diamonds = lazy(() => import("./Diamonds"));
const FineJewelry = lazy(() => import("./Fine_jewelry"));
const CustomDesign = lazy(() => import("./Custom_design"));
const Testimonial = lazy(() => import("./Testimonial"));
const Insta = lazy(() => import("./Insta"));
const OurDiff = lazy(() => import("./OurDiff"));

const Home = () => {
  const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isPopupLoaded, setIsPopupLoaded] = useState(false);
  const [homeBanner, setHomeBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useLayoutEffect(() => {
    setIsLoading(true);
    axios
      .get(`${base_url}/common/home_banner`)
      .then((res) => {
        if (res?.data?.status === 1) {
          setIsLoading(false);
          setHomeBanner(res?.data?.data);
        }
      })
      .catch((error) => console.error("Banner Fetch Error:", error));
  }, [window.location]); // Fetch once on mount

  // Handle screen resize
  useLayoutEffect(() => {
    const resizeScreen = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", resizeScreen);
    return () => window.removeEventListener("resize", resizeScreen);
  }, []);

  // Load Klaviyo Popup After Home Page Renders
  // useEffect(() => {
  //   const loadPopup = () => {
  //     if (!document.querySelector('script[src*="klaviyo.com"]')) {
  //       const script = document.createElement("script");
  //       script.src = "//static.klaviyo.com/onsite/js/klaviyo.js?company_id=X5zDFP";
  //       script.async = true;
  //       script.onload = () => setIsPopupLoaded(true);
  //       document.body.appendChild(script);
  //     }
  //   };
  //   if ("requestIdleCallback" in window) {
  //     requestIdleCallback(loadPopup);
  //   } else {
  //     setTimeout(loadPopup, 3000);
  //   }
  // }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.title || "Wedding Day Diamonds"}</title>
        {metaData?.description && <meta name="description" content={metaData.description} />}
      </Helmet>

      <div className="wdd_home">
        <section className="main_banner">
          {isLoading ?
            <Skeleton variant="rectangular" style={{ margin: "0 auto", height: screenWidth > 1024 ? "500px" : screenWidth > 767 ? "240px" : "350px" }} />
            :
            <Link to={homeBanner?.link || "#"}>
              <picture>
                <source srcSet={screenWidth > 767 ? homeBanner?.banner_webp : homeBanner?.banner_mobile_webp} type="image/webp" />
                <img
                  className="w-100 h-auto"
                  src={screenWidth > 767 ? homeBanner?.banner : homeBanner?.banner_mobile}
                  width={screenWidth > 767 ? "1200" : "768"}
                  height={screenWidth > 767 ? "600" : "400"}
                  alt="Promotional home banner"
                  fetchPriority="high"
                // loading="lazy"
                />
              </picture>
            </Link>
          }
        </section>
        {/* Main Content - Loads First */}
        {/* <Suspense fallback={<Skeleton height={300} />}>
          <DynamicHomeBanner responsive={screenWidth} />
        </Suspense> */}

 
            <Suspense fallback={<Skeleton height={200} />}>
          <TitleContent responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <ShopShape responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <ShopByStyle responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <Features responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <Diamonds responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <FineJewelry responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <CustomDesign responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <Insta responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <Testimonial responsive={screenWidth} />
        </Suspense>
        <Suspense fallback={<Skeleton height={200} />}>
          <OurDiff responsive={screenWidth} />
        </Suspense>

        {/* Popup Loads After Page Renders */}
        {isPopupLoaded && <div className="needsclick kl-private-reset-css-Xuajs1"></div>}
      </div>
    </>
  );
};

export default Home;